module.exports =(function() {
  return function(context) {
    return (function() {
      var $c, $e, $o, i, j, len, len1, ref, ref1, topic;
      $e = function(text, escape) {
        return ("" + text).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/'/g, '&#39;').replace(/\//g, '&#47;').replace(/"/g, '&quot;');
      };
      $c = function(text) {
        switch (text) {
          case null:
          case void 0:
            return '';
          case true:
          case false:
            return '' + text;
          default:
            return text;
        }
      };
      $o = [];
      if (this.project.get("addTopicsSucceeded")) {
        $o.push("<div class='add-topics-row row-half topics'>\n  <h6 class='as-label'>Topics</h6>");
        ref = this.project.get("topics");
        for (i = 0, len = ref.length; i < len; i++) {
          topic = ref[i];
          $o.push("  <span class='comma'>" + ($e($c(topic))) + "</span>");
        }
        $o.push("</div>");
      } else if (this.topics) {
        $o.push("<form class='maskable' id='add-topics' data-validation='structured' data-projectId='" + ($e($c(this.project.get('id')))) + "'>\n  <input type='hidden' name='project-id' value='" + ($e($c(this.project.get('id')))) + "'>\n  <div class='add-topics-row row-half'>\n    <div class='interaction'>\n      <label class='required-select' for='topic_ids[]'>\n        <div class='required-select-labbel'>Topics</div>\n        <select class='js-topics-input select2-hidden-accessible' name='topic_ids[]' aria-hidden='true' required data-parsley-required-message='Please select at least one topic.' data-behavior='select2' data-select2options='{\"placeholder\": \"Select up to 3 topics you used to complete this project.\", \"maximumSelectionLength\": 3 }' multiple tabindex='-1'>");
        ref1 = this.topics;
        for (j = 0, len1 = ref1.length; j < len1; j++) {
          topic = ref1[j];
          $o.push("          <option value='" + ($e($c(topic.id))) + "' selected='" + ($e($c(this.project.get("topic_ids").indexOf(topic.id) >= 0))) + "'>" + ($e($c(topic.name))) + "</option>");
        }
        $o.push("        </select>\n      </label>\n    </div>");
        if (this.project.get("addTopicsSucceeded") === false) {
          $o.push("    <div class='add-topics-fail subtext'>Failed to add topics, please try again</div>");
        }
        $o.push("  </div>\n</form>");
      }
      return $o.join("\n").replace(/\s([\w-]+)='true'/mg, ' $1').replace(/\s([\w-]+)='false'/mg, '').replace(/\s(?:id|class)=(['"])(\1)/mg, "");
    }).call(context);
  };

}).call(this);



//////////////////
// WEBPACK FOOTER
// ./app/javascript/backbone/projects/templates/add_topics.js.hamlc
// module id = 1523
// module chunks = 18